import { HotelSearchWrapperViewPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-wrapper/hotel-search-wrapper.types";
import { useIsVisible } from "@website/hooks/is-visible";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const HotelSearchWrapperComponent: FC<HotelSearchWrapperViewPropertiesType> = (
  properties
) => {
  const { reference: scrollReference, inView } = useIsVisible({}, true);
  const {
    SummaryElement,
    PanelElement,
    searchType,
    isSearchPanelOpen,
    setIsSearchPanelOpen
  } = properties;

  return (
    <>
      {!["hotel", "villa"].includes(searchType ?? "") && (
        <div
          className="bg-on-surface-disable fixed left-0 top-[73px] z-10 box-border hidden h-screen w-full opacity-100 transition-all duration-200 ease-in-out lg:block"
          hidden={!isSearchPanelOpen}
          onClick={setIsSearchPanelOpen.bind(null, false)}
        />
      )}
      <div ref={scrollReference} />
      <div
        className={`relative top-0 z-10 w-full transition-shadow duration-200 ease-in-out ${
          ["hotel", "villa"].includes(searchType ?? "")
            ? "z-[1] h-[48px] lg:h-[40px]"
            : "lg:h-[72px]"
        } ${
          !inView && !["hotel", "villa"].includes(searchType ?? "")
            ? "shadow-4 !fixed right-0 top-0"
            : ""
        }`}
      >
        <div
          className={`overflow-hidden bg-white transition-all duration-200 ease-in-out lg:absolute lg:top-0 lg:z-40 lg:w-full ${
            ["hotel", "villa"].includes(searchType ?? "")
              ? "h-[48px] lg:h-[72px]"
              : "h-[72px]"
          } ${
            isSearchPanelOpen && ["city", "category"].includes(searchType ?? "")
              ? "h-[236px] lg:h-[180px]"
              : "flex w-full justify-center"
          } ${isSearchPanelOpen ? "overflow-visible" : ""} ${
            isSearchPanelOpen && ["hotel", "villa"].includes(searchType ?? "")
              ? "border-secondary shadow-6 h-[144px] rounded-xl border-2 xl:h-[104px]"
              : ""
          } `}
        >
          <div
            className={`flex size-full items-center justify-center transition-all duration-200 ease-in-out ${
              ["hotel", "villa"].includes(searchType ?? "")
                ? "bg-dim-background"
                : "bg-white px-4"
            } ${
              isSearchPanelOpen
                ? "pointer-events-none hidden -translate-y-32 scale-75 opacity-0"
                : "translate-y-0 scale-100 opacity-100"
            }`}
          >
            <div
              className="w-full cursor-pointer"
              onClick={setIsSearchPanelOpen.bind(null, true)}
            >
              {SummaryElement}
            </div>
          </div>
          <div
            className={`absolute hidden size-full items-center justify-center transition-all duration-200 ease-in-out lg:flex ${
              isSearchPanelOpen
                ? "translate-y-0 scale-100 opacity-100"
                : "translate-y-32 scale-150 opacity-0"
            }`}
          >
            {isSearchPanelOpen && (
              <div
                className={`w-full p-6 xl:mx-auto xl:w-[1224px] ${
                  ["hotel", "villa"].includes(searchType ?? "")
                    ? "xl:w-[1104px]"
                    : "xl:w-[1224px]"
                }`}
              >
                {PanelElement}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="lg:hidden">
        <Modal
          closeIcon={
            ["hotel", "villa"].includes(searchType ?? "")
              ? "arrow_forward"
              : "close"
          }
          headerStyle={
            ["hotel", "villa"].includes(searchType ?? "")
              ? "block h-[64px]"
              : ""
          }
          onClose={setIsSearchPanelOpen.bind(null, false)}
          open={isSearchPanelOpen || false}
          showCloseButton
          iconClassName="!mb-3 !mr-0"
        >
          {PanelElement}
        </Modal>
      </div>
      <div
        className={
          !inView && !["hotel", "villa"].includes(searchType ?? "")
            ? "h-[72px]"
            : "hidden"
        }
      />
    </>
  );
};

export const HotelSearchWrapper = memo(
  HotelSearchWrapperComponent,
  deepCompare
);
